import photo1 from "../assets/info/chrysler-300c/chrysler-300c-2012-side.jpg";
import photo2 from "../assets/info/chrysler-300c/chrysler-300c-2007-side.jpg";
import photo3 from "../assets/info/dacia-duster/Dacia-Duster-side.jpg";
import photo4 from "../assets/info/dacia-duster/Dacia-Duster-side-1.jpg";
import photo5 from "../assets/info/ford-ranger/2019-Raptor.jpg";
import photo6 from "../assets/info/ford-ranger/Ford-Ranger-III-Double-Cab-facelift-2019.jpg";
import photo7 from "../assets/info/ford-ranger/PXMKIII-2-Ranger.jpg";
import photo8 from "../assets/info/ford-ranger/Ford-Ranger-2WD-Lo-Ride-2018-2.jpg";
import photo9 from "../assets/info/ford-ranger/ranger4wd2015.jpg";
import photo10 from "../assets/info/ford-ranger/2014-Ford-Ranger-Resized.jpg";
import photo11 from "../assets/info/ford-ranger/ranger4wd2009.jpg";
import photo12 from "../assets/info/ford-ranger/ranger4wd2006.jpg";
import photo13 from "../assets/info/ford-mustang/2019-Mustang-Coupe-V8.jpg";
import photo14 from "../assets/info/ford-mustang/2019-Mustang-Coupe-V6.jpg";
import photo15 from "../assets/info/ford-mustang/2019-Mustang-Convertible-V8.jpg";
import photo16 from "../assets/info/ford-mustang/2019-Mustang-Convertible-V6.jpg";
import photo17 from "../assets/info/ford-mustang/2016-Mustang-Coupe-5L.jpg";
import photo18 from "../assets/info/ford-mustang/2016-Mustang-Coupe-V6.jpg";
import photo19 from "../assets/info/ford-mustang/2016-Mustang-Convertible-V8.jpg";
import photo20 from "../assets/info/ford-mustang/2016-Mustang-Convertible-V6.jpg";
import photo21 from "../assets/info/ford-mustang/Ford-Mustang-2004.jpg";
import photo22 from "../assets/info/santa-fe/1.jpg";
import photo23 from "../assets/info/santa-fe/2.jpg";
import photo24 from "../assets/info/santa-fe/3.jpg";
import photo25 from "../assets/info/santa-fe/4.jpg";
import photo26 from "../assets/info/isuzu-d-max/2021-isuzu-dmax.jpg";
import photo27 from "../assets/info/isuzu-d-max/dmax-side-bar-1.jpg";
import photo28 from "../assets/info/isuzu-d-max/model-d-max-12.jpg";
import photo29 from "../assets/info/isuzu-d-max/model-d-max-08.jpg";
import photo30 from "../assets/info/jeep-wrangler/2019-JL-SWB.jpg";
import photo31 from "../assets/info/jeep-wrangler/Jeep-Wrangler-JL.jpg";
import photo32 from "../assets/info/jeep-wrangler/wrangler-swb-1.jpg";
import photo33 from "../assets/info/jeep-wrangler/wrangler-swb.jpg";
import photo34 from "../assets/info/jeep-wrangler/jeep-lwb-side-1.jpg";
import photo35 from "../assets/info/jeep-wrangler/jeep-lwb-side.jpg";
import photo36 from "../assets/info/kia-sorento/sorentofwd2015.jpg";
import photo37 from "../assets/info/kia-sorento/model-sorento-um15.jpg";
import photo38 from "../assets/info/kia-sorento/model-sorento-xm12.jpg";
import photo39 from "../assets/info/kia-sorento/model-sorento-xm09.jpg";
import photo40 from "../assets/info/kia-sorento/model-sorento-02.jpg";
import photo41 from "../assets/info/mercedes-x-class/x350d.jpg";
import photo42 from "../assets/info/mercedes-x-class/x250d.jpg";
import photo43 from "../assets/info/mercedes-x-class/x200.jpg";
import photo44 from "../assets/info/mercedes-x-class/x250d-2.jpg";
import photo45 from "../assets/info/mercedes-x-class/x220d.jpg";
import photo46 from "../assets/info/mazda-mx-5/ND-2.0-MX5.jpg";
import photo47 from "../assets/info/mazda-mx-5/ND-1.5-MX5.jpg";
import photo48 from "../assets/info/mazda-mx-5/NC-MX5.jpg";
import photo49 from "../assets/info/mazda-mx-5/NB-MX5.jpg";
import photo50 from "../assets/info/mazda-mx-5/NA-MX5.jpg";
import photo51 from "../assets/info/mitsubishi-l200/mr-l200.jpg";
import photo52 from "../assets/info/mitsubishi-l200/triton-sidebar.jpg";
import photo53 from "../assets/info/mitsubishi-l200/l200-2015-mn.png";
import photo54 from "../assets/info/mitsubishi-l200/model-l200-06.jpg";
import photo55 from "../assets/info/mitsubishi-l200/model-l200-96.jpg";
import photo56 from "../assets/info/mitsubishi-l200/model-l200-91.jpg";
import photo57 from "../assets/info/mitsubishi-l200/mitsl200-1986mh.jpg";
import photo58 from "../assets/info/mitsubishi-pajero/model-pajero-06-lwb.jpg";
import photo59 from "../assets/info/mitsubishi-pajero/model-pajero-06-swb.jpg";
import photo60 from "../assets/info/mitsubishi-pajero/model-pajero-00-lwb.jpg";
import photo61 from "../assets/info/mitsubishi-pajero/model-pajero-91-swb.jpg";
import photo62 from "../assets/info/mitsubishi-pajero/model-pajero-91-lwb.jpg";
import photo63 from "../assets/info/mitsubishi-pajero/model-pajero-91.jpg";
import photo64 from "../assets/info/mitsubishi-pajero/pajero-1988nb.jpg";
import photo65 from "../assets/info/mitsubishi-pajero/pajero-1982na.jpg";
import photo66 from "../assets/info/mitsubishi-shogun-sport/model-shogun-sport-09.jpg";
import photo67 from "../assets/info/mitsubishi-shogun-sport/model-shogun-sport-00.jpg";
import photo68 from "../assets/info/mitsubishi-shogun-sport/model-shogun-sport-96.jpg";
import photo69 from "../assets/info/nissan-navara/d23-400.jpg";
import photo70 from "../assets/info/nissan-navara/model-navara-d40.jpg";
import photo71 from "../assets/info/nissan-navara/model-navara-85-4wd.jpg";
import photo72 from "../assets/info/nissan-pathfinder/pathfinderr52.jpg";
import photo73 from "../assets/info/nissan-pathfinder/pathfinderr51.jpg";
import photo74 from "../assets/info/nissan-pathfinder/model-pathfinder-r50.jpg";
import photo75 from "../assets/info/nissan-pathfinder/pathfinderwd21.jpg";
import photo76 from "../assets/info/nissan-patrol/model-patrol-04-lwb.jpg";
import photo77 from "../assets/info/nissan-patrol/model-patrol-97-lwb.jpg";
import photo78 from "../assets/info/nissan-patrol/model-patrol-88-swb.jpg";
import photo79 from "../assets/info/nissan-patrol/model-patrol-88-lwb.jpg";
import photo80 from "../assets/info/nissan-x-trail/x-trail-side-3.jpg";
import photo81 from "../assets/info/nissan-x-trail/x-trail-side.jpg";
import photo82 from "../assets/info/nissan-x-trail/model-xtrail-t31.jpg";
import photo83 from "../assets/info/nissan-x-trail/model-xtrail-t30.jpg";
import photo84 from "../assets/info/subaru-forester/sj-forester.jpg";
import photo85 from "../assets/info/subaru-forester/sh-forester.jpg";
import photo86 from "../assets/info/subaru-forester/sg-forester_1.jpg";
import photo87 from "../assets/info/subaru-forester/sf-forester_1.jpg";
import photo88 from "../assets/info/subaru-impreza/1992-Impreza-GC.jpeg";
import photo89 from "../assets/info/subaru-impreza/1992-Impreza-GC-WRX.jpg";
import photo90 from "../assets/info/subaru-impreza/1992-Impreza-GF.jpeg";
import photo91 from "../assets/info/subaru-impreza/1992-Impreza-GF-WRX.jpg";
import photo92 from "../assets/info/subaru-impreza/Impreza-GD-Sedan.jpg";
import photo93 from "../assets/info/subaru-impreza/Impreza-GD-WRX.jpg";
import photo94 from "../assets/info/subaru-impreza/Impreza-GD-WRX-STi.jpg";
import photo95 from "../assets/info/subaru-impreza/2000-GG-Wagon.jpg";
import photo96 from "../assets/info/subaru-impreza/Impreza-GG-Wagon-WRX.jpeg";
import photo97 from "../assets/info/subaru-impreza/Impreza-Hawk-GD-Sedan.jpg";
import photo98 from "../assets/info/subaru-impreza/Impreza-Hawk-GD-Sedan-WRX.jpg";
import photo99 from "../assets/info/subaru-impreza/Impreza-Hawk-GD-Sedan-WRX-STi.jpg";
import photo100 from "../assets/info/subaru-impreza/Impreza-Blob-GG-Wagon.jpeg";
import photo101 from "../assets/info/subaru-impreza/Impreza-Hawk-GG-Wagon-WRX.jpg";
import photo102 from "../assets/info/subaru-impreza/Impreza-GE-GH.jpg";
import photo103 from "../assets/info/subaru-impreza/Impreza-GE-GH-Sti.jpg";
import photo104 from "../assets/info/subaru-impreza/Impreza-GV-WRX.jpg";
import photo105 from "../assets/info/subaru-impreza/Impreza-GV-WRX-STi.jpg";
import photo106 from "../assets/info/subaru-impreza/Impreza-GJ-Sedan.jpg";
import photo107 from "../assets/info/subaru-impreza/Impreza-GJ-Sedan-WRX.jpg";
import photo108 from "../assets/info/subaru-impreza/Impreza-GJ-Sedan-WRX-STi.jpg";
import photo109 from "../assets/info/subaru-outback/subaruoutlander2014on.jpg";
import photo110 from "../assets/info/subaru-outback/subaruoutback-brwagon2009.jpg";
import photo111 from "../assets/info/subaru-outback/subaruoutback-2003bp.jpg";
import photo112 from "../assets/info/subaru-outback/subaruoutback-1998bg.jpg";
import photo113 from "../assets/info/subaru-brz/suburu_brz.jpg";
import photo114 from "../assets/info/toyota-hilux-4wd/hilux-mk9-2021.jpg";
import photo115 from "../assets/info/toyota-hilux-4wd/hilux5.jpg";
import photo116 from "../assets/info/toyota-hilux-4wd/hilux-mk8-extra-cab.jpg";
import photo117 from "../assets/info/toyota-hilux-4wd/mk8-single-cab-hilux2.jpg";
import photo118 from "../assets/info/toyota-hilux-4wd/hilux4.jpg";
import photo119 from "../assets/info/toyota-hilux-4wd/hilux1.jpg";
import photo120 from "../assets/info/toyota-landcruiser/Landcruiser-120-LC.jpeg";
import photo121 from "../assets/info/toyota-landcruiser/uzj100-landcruiser.jpg";
import photo122 from "../assets/info/toyota-landcruiser/90-landcruiser-2.jpg";
import photo123 from "../assets/info/toyota-landcruiser/fj80-landcruiser-2.jpg";
import photo124 from "../assets/info/toyota-landcruiser/fzj80-landcruiser-2.jpg";
import photo125 from "../assets/info/toyota-gt86/toyota_gt86_red.jpg";
import photo126 from "../assets/info/vw-amarok/amarok-2.jpg";
import photo127 from "../assets/info/vw-amarok/vw-amarok.jpg";
import photo128 from "../assets/info/vw-amarok/V6-Amarok.jpg";
import photo129 from "../assets/info/vw-transporter/vw-transporter4.jpg";
import photo130 from "../assets/info/vw-transporter/vw-transporter1.jpg";
import photo131 from "../assets/info/vw-transporter/vw-transporter3.jpg";
import photo132 from "../assets/info/vw-golf/golfmk7-2.jpg";
import photo133 from "../assets/info/vw-golf/golfmk6.jpg";
import photo134 from "../assets/info/vw-golf/golfmk5.jpg";
import photo135 from "../assets/info/ford-ranger/2023-ranger-2.jpg";
import photo136 from "../assets/info/ford-ranger/Ranger_Next-Gen.png";

export const popularVehicle = [
  {
    make: "Chrysler",
    models: [
      {
        to: "/info-chrysler-300c",
        display: "Chrysler 300C",
        popular: [
          {
            photo: photo1,
            text: "Chrysler 300c 2012-On",
            link: "parts?make=Chrysler&model=300&year=2012-Onward",
          },
          {
            photo: photo2,
            text: "Chrysler 300c 2005-2012 3.0TD",
            link: "parts?make=Chrysler&model=300&year=3.0lt+6cyl+TD+%7C+2005-2012",
          },
        ],
      },
    ],
  },
  {
    make: "Dacia",
    models: [
      {
        to: "/info-dacia-duster",
        display: "Duster",
        popular: [
          {
            photo: photo3,
            text: "Dacia Duster 2009-Onward AWD 2.0L TD",
            link: "parts?make=Dacia&model=Duster&year=AWD%2C+2.0lt+4cyl+ULP+%7C+2009-Onward",
          },
          {
            photo: photo4,
            text: "Dacia Duster 2009-Onward AWD 1.5L 4cyl ULP",
            link: "parts?make=Dacia&model=Duster&year=AWD%2C+1.5lt+4cyl+TD+%7C+2009-Onward",
          },
        ],
      },
    ],
  },
  {
    make: "Ford",
    models: [
      {
        to: "/info-ford-ranger",
        display: "Ranger",
        popular: [
          {
            photo: photo135,
            text: "Ford Ranger 2023-Onwards 3.0 V6",
            link: "parts?make=Ford&year=P703+3.0+V6+%7C+2023-Onward&model=Ranger",
          },
          {
            photo: photo136,
            text: "Ford Ranger 2023-Onwards 2.0",
            link: "parts?make=Ford&year=P703+2.0+%7C+2023-Onward&model=Ranger",
          },
          {
            photo: photo5,
            text: "Ford Ranger 2019-On Raptor",
            link: "parts?make=Ford&model=Raptor&year=4WD%2C+2.0+Model+ONLY+%7C+2019-Onward",
          },
          {
            photo: photo6,
            text: "Ford Ranger 4WD PX MKIII 2.0L 07/2019-Onwards",
            link: "parts?make=Ford&model=Ranger&year=PX+MK3%2C+4WD+2.0+Model+ONLY+%7C+2019-Onward",
          },
          {
            photo: photo7,
            text: "Ford Ranger 4WD PX MKIII 3.2L Wildtrak 07/2019-Onwards",
            link: "parts?make=Ford&model=Ranger&year=PX+MK3%2C+4WD+3.2+Wildtrack+Model+ONLY+%7C+2019-Onward",
          },
          {
            photo: photo8,
            text: "Ford Ranger 4WD PX MKIII 2018-07/2019",
            link: "parts?make=Ford&model=Ranger&year=PX+MK3%2C+4WD+2.2L+and+3.2L+ONLY+%7C+2018-2019",
          },
          {
            photo: photo9,
            text: "Ford Ranger 4WD PX MKII 2015-2018",
            link: "parts?make=Ford&model=Ranger&year=PX+MK2%2C+4WD+%7C+2015-2018",
          },
          {
            photo: photo10,
            text: "Ford Ranger 4WD PX MKI 2011-2015",
            link: "parts?make=Ford&model=Ranger&year=PX%2C+4WD+%7C+2011-2015",
          },
          {
            photo: photo11,
            text: "Ford Ranger 4WD PK 2009-2011",
            link: "parts?make=Ford&model=Ranger&year=PK%2C+4WD+%7C+2009-2011",
          },
          {
            photo: photo12,
            text: "Ford Ranger 4WD PJ 2006-2009",
            link: "parts?make=Ford&model=Ranger&year=PJ%2C+4WD+%7C+2006-2009",
          },
        ],
      },
      {
        to: "/info-ford-mustang",
        display: "Mustang",
        popular: [
          {
            photo: photo13,
            text: "2018 on FN Coupe 5.0 V8",
            link: "parts?make=Ford&model=Mustang&year=FN+Coupe%2C+5.0lt+8cyl+ULP+%7C+2018-Onward",
          },
          {
            photo: photo14,
            text: "2018 on FN Coupe 2.3 Ecoboost",
            link: "parts?make=Ford&model=Mustang&year=FN+Coupe%2C+2.3lt+4cyl+TULP+%7C+2018-Onward",
          },
          {
            photo: photo15,
            text: "2018 on FN Convertible 5.0 V8",
            link: "parts?make=Ford&model=Mustang&year=FN+Convertible%2C+5.0lt+8cyl+ULP+%7C+2018-Onward",
          },
          {
            photo: photo16,
            text: "2018 on FN Convertible 2.3 Ecoboost",
            link: "parts?make=Ford&model=Mustang&year=FN+Convertible%2C+2.3lt+4cyl+TULP+%7C+2018-Onward",
          },
          {
            photo: photo17,
            text: "2015-2018 FM Coupe 5.0 V8",
            link: "parts?make=Ford&model=Mustang&year=FM+Coupe%2C+5.0lt+8cyl+ULP+%7C+2015-2018",
          },
          {
            photo: photo18,
            text: "2015-2018 FM Coupe 2.3 Ecoboost",
            link: "parts?make=Ford&model=Mustang&year=FM+Coupe%2C+2.3lt+4cyl+TULP+%7C+2015-2018",
          },
          {
            photo: photo19,
            text: "2015-2018 FM Convertible 5.0 V8",
            link: "parts?make=Ford&model=Mustang&year=FM+Convertible%2C+5.0lt+8cyl+ULP+%7C+2015-2018",
          },
          {
            photo: photo20,
            text: "2015-2018 FM Convertible 2.3 Ecoboost",
            link: "parts?make=Ford&model=Mustang&year=FM+Convertible%2C+2.3lt+4cyl+TULP+%7C+2015-2018",
          },
          {
            photo: photo21,
            text: "Ford Mustang 2004-2014 Coupe & Convertible",
            link: "parts?make=Ford&model=Mustang&year=Coupe+%26+Convertible+%7C+2004-2014",
          },
        ],
      },
    ],
  },
  {
    make: "Hyundai",
    models: [
      {
        to: "/info-hyundai-santa-fe",
        display: "Santa Fe",
        popular: [
          {
            photo: photo22,
            text: "Hyundai Santa Fe DM AWD 2012 + 2.2L",
            link: "parts?make=Hyundai&model=Santa+Fe&year=DM+AWD%2C+2.2lt+4cyl+TD+%7C+2012-Onward",
          },
          {
            photo: photo23,
            text: "Hyundai Santa Fe CM 2009 / 11 – 2012 2.2L",
            link: "parts?make=Hyundai&model=Santa+Fe&year=CM%2C+2.2lt+4cyl+TD+%7C+2009-2012",
          },
          {
            photo: photo24,
            text: "Hyundai Santa Fe CM 2006 - 10 / 2009 2.2L",
            link: "parts?make=Hyundai&model=Santa+Fe&year=CM%2C+2.2lt+4cyl+TD+%7C+2006-2009",
          },
          {
            photo: photo25,
            text: "Hyundai Santa Fe SM 2000 - 2006",
            link: "parts?make=Hyundai&model=Santa+Fe&year=SM+%7C+2000-2006",
          },
        ],
      },
    ],
  },
  {
    make: "Isuzu",
    models: [
      {
        to: "/info-isuzu-d-max",
        display: "D-Max",
        popular: [
          {
            photo: photo26,
            text: "Isuzu D Max 2020-On 4WD",
            link: "parts?make=Isuzu&model=D+Max&year=4WD+%28UK+%26+EU+Markets%29%2C+1.9lt+4cyl+TD+%7C+2021-Onward",
          },
          {
            photo: photo27,
            text: "Isuzu D Max 2017-On 4WD (UK & EU Markets) 1.9lt 4cyl TD",
            link: "parts?make=Isuzu&model=D+Max&year=4WD+%28UK+%26+EU+Markets%29%2C+1.9lt+4cyl+TD+%7C+2017-2020",
          },
          {
            photo: photo28,
            text: "Isuzu D Max 2012-2017 4WD 2.5TD",
            link: "parts?make=Isuzu&model=D+Max&year=4WD%2C+2.5TD+%7C+2012-2017",
          },
          {
            photo: photo29,
            text: "Isuzu D Max 2008-2012 TFR 4WD",
            link: "parts?make=Isuzu&model=D+Max&year=4WD%2C+3.0lt+4cyl+TD+%7C+2008-2012",
          },
        ],
      },
    ],
  },
  {
    make: "Jeep",
    models: [
      {
        to: "/info-jeep-wrangler",
        display: "Wrangler",
        popular: [
          {
            photo: photo30,
            text: "Jeep Wrangler 2019 on JL SWB",
            link: "parts?make=Jeep&model=Wrangler&year=JL+SWB+%7C+2019-Onward",
          },
          {
            photo: photo31,
            text: "Jeep Wrangler 2019-on JL LWB",
            link: "parts?make=Jeep&model=Wrangler&year=JL+LWB+%7C+2019-Onward",
          },
          {
            photo: photo32,
            text: "Jeep Wrangler 2007-on JK SWB 2.8lt 4cyl TD",
            link: "parts?make=Jeep&model=Wrangler&year=JK+SWB%2C+2.8lt+4cyl+TD+%7C+2007-Onward",
          },
          {
            photo: photo33,
            text: "Jeep Wrangler 2007-on JK SWB 3.6lt 6cyl ULP",
            link: "parts?make=Jeep&model=Wrangler&year=JK+LWB%2C+3.6lt+6cyl+ULP+%7C+2007-Onward",
          },
          {
            photo: photo34,
            text: "Jeep Wrangler 2007-on JK LWB 2.8lt 4cyl TD",
            link: "parts?make=Jeep&model=Wrangler&year=JK+LWB%2C+2.8lt+4cyl+TD+%7C+2007-Onward",
          },
          {
            photo: photo35,
            text: "Jeep Wrangler 2007-on JK LWB 3.6lt 6cyl UL",
            link: "parts?make=Jeep&model=Wrangler&year=JK+LWB%2C+3.6lt+6cyl+ULP+%7C+2007-Onward",
          },
        ],
      },
    ],
  },
  {
    make: "Kia",
    models: [
      {
        to: "/info-kia-sorento",
        display: "Sorento",
        popular: [
          {
            photo: photo36,
            text: "Kia Sorento UM FWD 2015 +",
            link: "parts?make=Kia&year=UM+FWD%2C+3.3lt+6cyl+ULP+%7C+2015-Onward&model=Sorento",
          },
          {
            photo: photo37,
            text: "Kia Sorento UM AWD 2015 +",
            link: "parts?make=Kia&year=UM+AWD%2C+2.2lt+4cyl+TD+%7C+2015-Onward&model=Sorento",
          },
          {
            photo: photo38,
            text: "Kia Sorento XM 2012 / 8 - 2015",
            link: "parts?make=Kia&year=XM+Gen+2+%7C+2012-2015&model=Sorento",
          },
          {
            photo: photo39,
            text: "Kia Sorento XM 2009 - 7 / 2012",
            link: "parts?make=Kia&year=XM+Gen+1+%7C+2009-2012&model=Sorento",
          },
          {
            photo: photo40,
            text: "Kia Sorento JC 2002 - 2009",
            link: "parts?make=Kia&year=JC+%7C+2002-2009&model=Sorento",
          },
        ],
      },
    ],
  },
  {
    make: "Mercedes",
    models: [
      {
        to: "/info-mercedes-x-class",
        display: "X-Class",
        popular: [
          {
            photo: photo41,
            text: "X350d 4 Door Pick-up 2018-on 3.0 V6 TD",
            link: "parts?make=Mercedes-Benz&year=X350d-3.0+V6+TD%2C+4+Door+Pick-up+%7C+2018-Onward&model=X-Class",
          },
          {
            photo: photo42,
            text: "X250d 4 Door Pick-up 2017-on BR470 2.3L TD",
            link: "parts?make=Mercedes-Benz&year=X250d-2.3lt+4cyl+TD%2C+4+Door+Pick-up+%7C+2017-Onward&model=X-Class",
          },
          {
            photo: photo43,
            text: "X250d 4 Door Pick-up 2017-on BR470 2.3L TTD",
            link: "parts?make=Mercedes-Benz&year=X250d-2.3lt+4cyl+TTD%2C+4+Door+Cab+Chassis+%7C+2017-Onward&model=X-Class",
          },
          {
            photo: photo44,
            text: "X220d 4 Door Pick-up 2017-on BR470 2.3L TTD",
            link: "parts?make=Mercedes-Benz&year=X220d-2.3lt+4cyl+TTD%2C+4+Door+pick-up+%7C+2017-Onward&model=X-Class",
          },
          {
            photo: photo45,
            text: "X220d 4 Door Pick-up 2017-on BR470 2.3L TD",
            link: "parts?make=Mercedes-Benz&year=X220d-2.3lt+4cyl+TD%2C+4+Door+pick-up+%7C+2017-Onward&model=X-Class",
          },
        ],
      },
    ],
  },
  {
    make: "Mazda",
    models: [
      {
        to: "/info-mazda-mx5",
        display: "MX5",
        popular: [
          {
            photo: photo46,
            text: "2015-On ND 2.0n",
            link: "parts?make=Mazda&year=ND%2C+2.0lt+4cyl+ULP+%7C+2015-Onward&model=MX5",
          },
          {
            photo: photo47,
            text: "2015-On ND 1.5",
            link: "parts?make=Mazda&year=ND%2C+1.5lt+4cyl+ULP+%7C+2015-Onward&model=MX5",
          },
          {
            photo: photo48,
            text: "2005-2015 NC",
            link: "parts?make=Mazda&year=NC3+%7C+2005-2015&model=MX5",
          },
          {
            photo: photo49,
            text: "1998-2005 NB",
            link: "parts?make=Mazda&year=NB%2C+1.6+4cyl+ULP%2C+1.8+4+cyl+ULP%2C+18+4cyl+TULP+%7C+1998-2005&model=MX5",
          },
          {
            photo: photo50,
            text: "1989-1997 NA6 & NA8",
            link: "parts?make=Mazda&year=NA6+%26+NA8+%7C+1989-1997&model=MX5",
          },
        ],
      },
    ],
  },
  {
    make: "Mitsubishi",
    models: [
      {
        to: "/info-mitsubishi-l200",
        display: "L200",
        popular: [
          {
            photo: photo51,
            text: "Mitsubishi L200 4WD 2018-on MR",
            link: "parts?make=Mitsubishi&year=4WD%2C+MR+%7C+2018-Onward&model=L200",
          },
          {
            photo: photo52,
            text: "Mitsubishi L200 4WD 2015-2018 MQ",
            link: "parts?make=Mitsubishi&year=4WD%2C+MQ+%7C+2015-2018&model=L200",
          },
          {
            photo: photo53,
            text: "Mitsubishi L200 4WD 2009-2015 MN",
            link: "parts?make=Mitsubishi&year=4WD%2C+MN+%7C+2009-2015&model=L200",
          },
          {
            photo: photo54,
            text: "Mitsubishi L200 4WD 2006-2009 ML",
            link: "parts?make=Mitsubishi&year=4WD%2C+ML+%28Coil+over+Frt%29+%7C+2006-2009&model=L200",
          },
          {
            photo: photo55,
            text: "Mitsubishi L200 4WD 1996-2006 MK",
            link: "parts?make=Mitsubishi&year=4WD%2C+MK+%28T%2FBar+Frt%29+%7C+1996-2006&model=L200",
          },
          {
            photo: photo56,
            text: "Mitsubishi L200 4WD 1991-1996 MJ",
            link: "parts?make=Mitsubishi&year=4WD%2C+MJ+%28T%2FBar+Frt%29+%7C+1991-1996&model=L200",
          },
          {
            photo: photo57,
            text: "Mitsubishi L200 4WD 1986-1991 MH",
            link: "parts?make=Mitsubishi&year=4WD%2C+MH+%28T%2FBar+Frt%29+%7C+1986-1991&model=L200",
          },
        ],
      },
      {
        to: "/info-mitsubishi-pajero",
        display: "Pajero & Shogun",
        popular: [
          {
            photo: photo58,
            text: "Mitsubishi Pajero LWB 2006- on",
            link: "parts?make=Mitsubishi&year=NS%2C+NT+%26+NW%2C+LWB+5+door+%7C+2006-2017&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo59,
            text: "Mitsubishi Pajero SWB 2006-on",
            link: "parts?make=Mitsubishi&year=NS%2C+NT+%26+NW%2C+SWB+3+door+%7C+2006-2017&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo60,
            text: "Mitsubishi Pajero LWB 2000-2006",
            link: "parts?make=Mitsubishi&year=NM+%26+NP%2C+LWB+5+door+%7C+2000-2006&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo61,
            text: "Mitsubishi Pajero NH to NL SWB 1991-2000",
            link: "parts?make=Mitsubishi&year=NH+to+NL+Coil+Rear%2C+SWB+%7C+1991-2000&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo62,
            text: "Mitsubishi Pajero NH to NL LWB 1991-2000",
            link: "parts?make=Mitsubishi&year=NH+to+NL+Coil+Rear%2C+LWB+%7C+1991-2000&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo63,
            text: "Mitsubishi Pajero NH to NJ Leaf Rear 1991-1996",
            link: "parts?make=Mitsubishi&year=NH+%26+NJ+Leaf%2C+Leaf+Rear+%7C+1991-1996&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo64,
            text: "Mitsubishi Pajero NB, NC & ND LWB & SWB 1984-1988",
            link: "parts?make=Mitsubishi&year=NB%2C+NC+%26+ND%2C+LWB+%26+SWB+%7C+1984-1988&model=Shogun+%2F+Pajero",
          },
          {
            photo: photo65,
            text: "Mitsubishi Pajero NA LWB & SWB 1982-1984",
            link: "parts?make=Mitsubishi&year=NA%2C+LWB+%26+SWB+%7C+1982-1984&model=Shogun+%2F+Pajero",
          },
        ],
      },
      {
        to: "/info-mitsubishi-shogun",
        display: "Shogun Sport",
        popular: [
          {
            photo: photo66,
            text: "Mitsubishi Shogun Sport PB 2009-2013",
            link: "parts?make=Mitsubishi&year=PB+%7C+2009-2013&model=Shogun+Sport",
          },
          {
            photo: photo67,
            text: "Mitsubishi Shogun Sport PA 2000-2006",
            link: "parts?make=Mitsubishi&year=PA+Coil+Rear+Susp+%7C+2000-2006&model=Shogun+Sport",
          },
          {
            photo: photo68,
            text: "Mitsubishi Shogun Sport PA 1996-2000",
            link: "parts?make=Mitsubishi&year=PA+Leaf+Spring+Rear+%7C+1996-2000&model=Shogun+Sport",
          },
        ],
      },
    ],
  },
  {
    make: "Nissan",
    models: [
      {
        to: "/info-nissan-navara",
        display: "Navara",
        popular: [
          {
            photo: photo69,
            text: "Nissan Navara D23 4WD 2015-On",
            link: "parts?make=Nissan&year=D23%2C+NP300+4WD+Coil+Spring+Rear+%7C+2015-Onward&model=Navara",
          },
          {
            photo: photo70,
            text: "Nissan Navara D40 2005-2015",
            link: "parts?make=Nissan&year=D40%2C+2WD+%26+4WD+Leaf+Over+Axle+%7C+2005-2015&model=Navara",
          },
          {
            photo: photo71,
            text: "Nissan Navara D21 & D22 4WD 1985-on",
            link: "parts?make=Nissan&year=D21+%26+D22%2C+4WD+%7C+1985-2015&model=Navara",
          },
        ],
      },
      {
        to: "/info-nissan-pathfinder",
        display: "Pathfinder",
        popular: [
          {
            photo: photo72,
            text: "Nissan Pathfinder R52",
            link: "parts?make=Nissan&year=R52+%7C+2013-Onward&model=Pathfinder",
          },
          {
            photo: photo73,
            text: "Nissan Pathfinder R51",
            link: "parts?make=Nissan&year=R51+%7C+2005-2012&model=Pathfinder",
          },
          {
            photo: photo74,
            text: "Nissan Pathfinder R50",
            link: "parts?make=Nissan&year=R50+%7C+1995-2005&model=Pathfinder",
          },
          {
            photo: photo75,
            text: "Nissan Pathfinder WD21",
            link: "parts?make=Nissan&year=WD21+%7C+1986-1995&model=Pathfinder",
          },
        ],
      },
      {
        to: "/info-nissan-patrol",
        display: "Patrol",
        popular: [
          {
            photo: photo76,
            text: "Nissan Patrol Y61 LWB 2002-2016",
            link: "parts?make=Nissan&year=GUII+%28Y61%29%2C+5+Door+Wagon+%7C+2002-2016&model=Patrol",
          },
          {
            photo: photo77,
            text: "Nissan Patrol Y61 LWB 1997-2001",
            link: "parts?make=Nissan&year=GU+%28Y61%29%2C+5+Door+Wagon+%7C+1997-2001&model=Patrol",
          },
          {
            photo: photo78,
            text: "Nissan Patrol Y60 SWB 1988-1997",
            link: "parts?make=Nissan&year=GQ+%26+GQII+%28Y60%29%2C+3+Door+Wagon+%7C+1988-1997&model=Patrol",
          },
          {
            photo: photo79,
            text: "Nissan Patrol Y60 LWB 1988-1997",
            link: "parts?make=Nissan&year=GQ+%26+GQII+%28Y60%29%2C+5+Door+Wagon+%7C+1988-1997&model=Patrol",
          },
        ],
      },
      {
        to: "/info-nissan-x-trail",
        display: "X-Trail",
        popular: [
          {
            photo: photo80,
            text: "Nissan X-Trail 2016 T32 Series II AWD",
            link: "parts?make=Nissan&year=GQ+%26+GQII+%28Y60%29%2C+5+Door+Wagon+%7C+1988-1997&model=Patrol",
          },
          {
            photo: photo81,
            text: "Nissan X-Trail 2014 - 2016 T32 Series I AWD",
            link: "parts?make=Nissan&year=T32+Series+1+AWD%2C+1.6+D+4cyl+%7C+2014-2016&model=X-Trail",
          },
          {
            photo: photo82,
            text: "Nissan X-Trail 2007 - 2014 T31",
            link: "parts?make=Nissan&year=T31+%7C+2007-2014&model=X-Trail",
          },
          {
            photo: photo83,
            text: "Nissan X-Trail 2001 - 2007 T30 2.2lt 4cyl TD",
            link: "parts?make=Nissan&year=T30%2C+2.2lt+4cyl+TD+%7C+2001-2009&model=X-Trail",
          },
        ],
      },
    ],
  },
  {
    make: "Subaru",
    models: [
      {
        to: "/info-subaru-forester",
        display: "Forester",
        popular: [
          {
            photo: photo84,
            text: "2013- SJ Model",
            link: "parts?make=Subaru&year=SJ+Model+%7C+2013-2018&model=Forester",
          },
          {
            photo: photo85,
            text: "2008-2013 SH Model",
            link: "parts?make=Subaru&year=SH+Model+%7C+2008-2013&model=Forester",
          },
          {
            photo: photo86,
            text: "2002-2008 SG Model",
            link: "parts?make=Subaru&year=SG+Model+%7C+2002-2008&model=Forester",
          },
          {
            photo: photo87,
            text: "1997-2002 SF Model",
            link: "parts?make=Subaru&year=SF+Model+%7C+1997-2002&model=Forester",
          },
        ],
      },
      {
        to: "/info-subaru-impreza",
        display: "Impreza",
        popular: [
          {
            photo: photo88,
            text: "1992-2000 GC Sedan",
            link: "parts?make=Subaru&year=GC%2C+Sedan+%7C+1992-2000&model=Impreza",
          },
          {
            photo: photo89,
            text: "1994-2000 GC WRX Sedan",
            link: "parts?make=Subaru&year=GC+WRX%2C+Sedan+%7C+1994-2000&model=Impreza",
          },
          {
            photo: photo90,
            text: "1992-2000 GF Wagon",
            link: "parts?make=Subaru&year=GF%2C+Wagon+%7C+1992-2000&model=Impreza",
          },
          {
            photo: photo91,
            text: "1994-2000 GF WRX Wagon",
            link: "parts?make=Subaru&year=GF+WRX%2C+Wagon+%7C+1994-2000&model=Impreza",
          },
          {
            photo: photo92,
            text: "2000-2002 GD Sedan",
            link: "parts?make=Subaru&year=GD%2C+Sedan+%7C+2000-2002&model=Impreza",
          },
          {
            photo: photo93,
            text: "2000-2002 GD WRX Sedan",
            link: "parts?make=Subaru&year=GD+WRX%2C+Sedan+%7C+2000-2002&model=Impreza",
          },
          {
            photo: photo94,
            text: "2000-2002 GD WRX STi Sedan",
            link: "parts?make=Subaru&year=GD+WRX+STi%2C+Sedan+%7C+2000-2002&model=Impreza",
          },
          {
            photo: photo95,
            text: "2000-2002 GG Wagon",
            link: "parts?make=Subaru&year=GG%2C+Wagon+%7C+2000-2002&model=Impreza",
          },
          {
            photo: photo96,
            text: "2000-2002 GG WRX Wagon",
            link: "parts?make=Subaru&year=GG+WRX%2C+Wagon+%7C+2000-2002&model=Impreza",
          },
          {
            photo: photo97,
            text: "2002-2007 GD Sedan",
            link: "parts?make=Subaru&year=GD%2C+Sedan+%7C+2002-2007&model=Impreza",
          },
          {
            photo: photo98,
            text: "2002-2007 GD WRX Sedan",
            link: "parts?make=Subaru&year=GD+WRX%2C+Sedan+%7C+2002-2007&model=Impreza",
          },
          {
            photo: photo99,
            text: "2005-2007 GD WRX STi Sedan",
            link: "parts?make=Subaru&year=GD+WRX+STi%2C+Sedan+%7C+2005-2007&model=Impreza",
          },
          {
            photo: photo100,
            text: "2002-2007 GG Wagon",
            link: "parts?make=Subaru&year=GG%2C+Wagon+%7C+2002-2007&model=Impreza",
          },
          {
            photo: photo101,
            text: "2002-2007 GG WRX Wagon",
            link: "parts?make=Subaru&year=GG+WRX%2C+Wagon+%7C+2002-2007&model=Impreza",
          },
          {
            photo: photo102,
            text: "2007-2011 GE/GH",
            link: "parts?make=Subaru&year=GE+%26+GH+%7C+2007-2011&model=Impreza",
          },
          {
            photo: photo103,
            text: "2007-2011 GE/GH WRX & STI",
            link: "parts?make=Subaru&year=GE+%26+GH+WRX+%26+STi+%7C+2007-2011&model=Impreza",
          },
          {
            photo: photo104,
            text: "2011-2013 GV WRX",
            link: "parts?make=Subaru&year=GV+WRX+%7C+2011-2013&model=Impreza",
          },
          {
            photo: photo105,
            text: "2011-2014 GV WRX STi Sedan",
            link: "parts?make=Subaru&year=GV+WRX+Sti%2C+Sedan+%7C+2011-2014&model=Impreza",
          },
          {
            photo: photo106,
            text: "2011-2014 GJ/GP",
            link: "parts?make=Subaru&year=GJ+%26+GP+%7C+2011-2014&model=Impreza",
          },
          {
            photo: photo107,
            text: "2011-2014 GJ/GP WRX",
            link: "parts?make=Subaru&year=GJ+%26+GP+WRX+%7C+2011-2014&model=Impreza",
          },
          {
            photo: photo108,
            text: "2011-2014 GJ/GP WRX STi",
            link: "parts?make=Subaru&year=GJ+%26+GP+WRX+STi+%7C+2011-2014&model=Impreza",
          },
        ],
      },
      {
        to: "/info-subaru-outback",
        display: "Outback",
        popular: [
          {
            photo: photo109,
            text: "Subaru Outback BS 2014 - on 2.0",
            link: "parts?make=Subaru&year=BS%2C+2.0+AWD+%7C+2014-2020&model=Outback",
          },
          {
            photo: photo110,
            text: "Subaru Outback BR Wagon 2009 - 2014",
            link: "parts?make=Subaru&year=BR%2C+2.5lt+4cyl+ULP+%7C+2009-2014&model=Outback",
          },
          {
            photo: photo111,
            text: "Subaru Outback BP 2003 - 2009",
            link: "parts?make=Subaru&year=BP+%7C+2003-2009&model=Outback",
          },
          {
            photo: photo112,
            text: "Subaru Outback BH 1998 - 2003",
            link: "parts?make=Subaru&year=BH%2C+2.5lt+4cyl+ULP+%7C+1998-2003&model=Outback",
          },
        ],
      },
      {
        to: "/info-subaru-brz",
        display: "BRZ",
        popular: [
          {
            photo: photo113,
            text: "Subaru BRZ",
            link: "parts?make=Subaru&year=Z1%2C+2.0lt+4cyl+ULP+%7C+2012-Onward&model=BRZ",
          },
        ],
      },
    ],
  },
  {
    make: "Toyota",
    models: [
      {
        to: "/info-toyota-hilux",
        display: "Hilux 4WD",
        popular: [
          {
            photo: photo114,
            text: "Toyota Hilux MK 9 2021-Onward 4WD",
            link: "parts?make=Toyota&model=Hilux+4WD&year=MK9+GGN125R%2C+GUN125R%2C+GUN126R+%7C+2020-Onward",
          },
          {
            photo: photo115,
            text: "Toyota Hilux MK 8 2015-2020 Double Cab",
            link: "parts?make=Toyota&year=MK8+GUN125R%2C+Double+Cab+Tub+Body+%7C+2015-Onward&model=Hilux+4WD",
          },
          {
            photo: photo116,
            text: "Toyota Hilux MK 8 2015-2020 Extra Cab",
            link: "parts?make=Toyota&year=MK8+GUN125R%2C+Extra+Cab+Cab-Chassis+%7C+2015-Onward&model=Hilux+4WD",
          },
          {
            photo: photo117,
            text: "Toyota Hilux MK 8 2015-2020 Single Cab",
            link: "parts?make=Toyota&year=MK8+GUN125R%2C+Single+Cab+Cab-Chassis+%7C+2015-Onward&model=Hilux+4WD",
          },
          {
            photo: photo118,
            text: "Toyota Hilux MK7 (2010-2015)",
            link: "parts?make=Toyota&year=MK7+GGN25%2C+KUN25R%2C+KUN26R%2C+GGN25%2C+KUN25R+KUN26R+%7C+2010-2015&model=Hilux+4WD",
          },
          {
            photo: photo119,
            text: "Toyota Hilux MK6 KUN25/26 (2005-2011)",
            link: "parts?make=Toyota&year=MK6+GGN25%2C+KUN25R%2C+KUN26R%2C+GGN25%2C+KUN25R%2C+KUN26R+%7C+2005-2010&model=Hilux+4WD",
          },
        ],
      },
      {
        to: "/info-toyota-landcruiser",
        display: "Landcruiser",
        popular: [
          {
            photo: photo120,
            text: "120 Series 09/2002 - 10/2009",
            link: "parts?make=Toyota&year=120+series%2C+LC3+LC5%2C+KDJ120%2C+KZJ120%2C+RZJ120+%26+GRJ12+%7C+2002-2009&model=Landcruiser",
          },
          {
            photo: photo121,
            text: "100 Series 1998-2007 HD, FZJ & UZJ100",
            link: "parts?make=Toyota&year=100+Series%2C+HD%2C+FZJ+%26+UZJ100+IFS+%7C+1998-2007&model=Landcruiser",
          },
          {
            photo: photo122,
            text: "90 Series 07/1996 - 08/2002",
            link: "parts?make=Toyota&year=90+series%2C+LWB%2C+KZJ95%2C+RZJ95+%26+VZJ95+%7C+1996-2002&model=Landcruiser",
          },
          {
            photo: photo123,
            text: "80 Series 1990-1992 FJ80 & HDJ80",
            link: "parts?make=Toyota&year=80+Series%2C+FJ80+%26+HDJ80+%7C+1990-1992&model=Landcruiser",
          },
          {
            photo: photo124,
            text: "80 Series 1992-1998 FZJ80, HDJ80 & HZJ80",
            link: "parts?make=Toyota&year=80+Series%2C+FZJ80%2C+HDJ80+%26+HZJ80+%7C+1992-1998&model=Landcruiser",
          },
        ],
      },
      {
        to: "/info-toyota-gt86",
        display: "GT86",
        popular: [
          {
            photo: photo125,
            text: "Toyota GT86 2.0L 2012-Onwards",
            link: "parts?make=Toyota&year=ZN6%2C+2.0lt+4cyl+ULP+%7C+2012-Onward&model=GT86",
          },
        ],
      },
    ],
  },
  {
    make: "Volkswagen",
    models: [
      {
        to: "/info-volkswagen-amarok",
        display: "Amarok",
        popular: [
          {
            photo: photo126,
            text: "Volkswagen Amarok 2010-2023 2H 2.0L TTD",
            link: "parts?make=Volkswagen&year=2H%2C+2.0lt+4cy+TTD+%7C+2010-2023&model=Amarok",
          },
          {
            photo: photo127,
            text: "Volkswagen Amarok 2010-2023 2H 2.0L TD",
            link: "parts?make=Volkswagen&year=2H%2C+2.0lt+4cyl+TD+%7C+2010-2023&model=Amarok",
          },
          {
            photo: photo128,
            text: "Volkswagen Amarok 2010-2023 2H 3.0L TD",
            link: "parts?make=Volkswagen&year=2H%2C+3.0lt+6cyl+TD+%7C+2010-2023&model=Amarok",
          },
        ],
      },
      {
        to: "/info-volkswagen-transporter",
        display: "Transporter",
        popular: [
          {
            photo: photo129,
            text: "2015-Onwards T6 FWD",
            link: "parts?make=Volkswagen&year=T6%2C+FWD+%7C+2015-Onward&model=Transporter",
          },
          {
            photo: photo130,
            text: "2003-7/2015 T5 FWD",
            link: "parts?make=Volkswagen&year=T5%2C+FWD+%7C+2003-2015&model=Transporter",
          },
          {
            photo: photo131,
            text: "1990-2003, T4",
            link: "parts?make=Volkswagen&year=T4+%7C+1990-2003&model=Transporter",
          },
        ],
      },
      {
        to: "/info-volkswagen-golf",
        display: "Golf",
        popular: [
          {
            photo: photo132,
            text: "Volkswagen Golf MK7",
            link: "parts?make=Volkswagen&year=MK7+%7C+2012-2019&model=Golf",
          },
          {
            photo: photo133,
            text: "Volkswagen Golf MK6",
            link: "parts?make=Volkswagen&year=MK6+5K+%7C+2009-2013&model=Golf",
          },
          {
            photo: photo134,
            text: "Volkswagen Golf MK5",
            link: "parts?make=Volkswagen&year=MK5%2C1K+%7C+2003-2009&model=Golf",
          },
        ],
      },
    ],
  },
];
